(function (window, document) {
  'use strict';

  const params = new URLSearchParams(window.location.search);
  const answer = (params.get('answer') || '').trim().toLowerCase();

  if (answer !== 'yes' && answer !== 'no') {
    return;
  }

  window.SaboGiftingReCollabMode = true;

  const token = (params.get('token') || '').trim();
  const submission = (params.get('submission') || '').trim();
  const proxyRoot = '/apps/gifting';

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function findRoot() {
    return (
      document.querySelector('[data-gifting-root]') ||
      document.querySelector('#gifting-app') ||
      document.querySelector('.gifting-page') ||
      document.querySelector('[data-gifting-page]') ||
      null
    );
  }

  function renderCard(title, message) {
    return (
      '<div class="gifting-recollab">' +
      '<div class="gifting-recollab__card">' +
      '<h1 class="gifting-recollab__title">' +
      escapeHtml(title) +
      '</h1>' +
      '<p class="gifting-recollab__message">' +
      escapeHtml(message) +
      '</p>' +
      '</div>' +
      '</div>'
    );
  }

  function show(title, message) {
    const html = renderCard(title, message);
    const root = findRoot();

    if (root) {
      root.innerHTML = html;
      return;
    }

    const main = document.querySelector('main') || document.body;
    main.innerHTML = html;
  }

  show('One moment', 'Saving your response…');

  if (!token) {
    show(
      'Link not valid',
      'This link is missing required information. Please use the link from your email or contact the Sabo team.'
    );
    return;
  }

  let url =
    proxyRoot +
    '/re-collab?answer=' +
    encodeURIComponent(answer) +
    '&token=' +
    encodeURIComponent(token);

  if (submission) {
    url += '&submission=' + encodeURIComponent(submission);
  }

  fetch(url, {
    method: 'GET',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      const title = data.Title || (data.Success ? 'Thank you' : 'Link not valid');
      const message = data.Message || '';
      show(title, message);
    })
    .catch(function () {
      show('Something went wrong', 'Please try the link in your email again or contact the Sabo team.');
    });
})(window, document);
